import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

export default function ProductCard({
  id,
  image,
  title,
  brand,
  color,
  sizes,
  rating,
  price,
  handleCartUpdate,
}) {
  const [selectedSize, setSelectedSize] = useState("");
  const [inventory, setInventory] = useState();
  const [notSelected, setNotSelected] = useState(false);
  const [outOfStock, setOutOfStock] = useState(false);
  // const [colorCode, setColorCode] = useState("");

  //console.log("show", showPopup);
  // useEffect(() => {
  //   //console.log("product", showPopup);
  //   const code =
  //     color?.toLowerCase() === "black" || color?.toLowerCase() === "white"
  //       ? `bg-${color?.toLowerCase()} text-${color?.toLowerCase()}`
  //       : `bg-${color?.toLowerCase()}-400 text-${color?.toLowerCase()}-400`;
  //   console.log(code);
  //   setColorCode(code);
  // }, [color]);

  // checks if inventory is available or not
  useEffect(() => {
    if (sizes) {
      for (let i = 0; i < sizes?.length; i++) {
        if (sizes[i].inventory > 0) {
          setOutOfStock(false);
          break;
        }
        setOutOfStock(true);
      }
    }
  }, []);

  // updates size and inventory on selecting
  const handleChange = (e) => {
    setSelectedSize(e.target.value);
    sizes?.map((size) => {
      if (size.size === e.target.value) {
        setInventory(size.inventory);
        console.log("Inventory Set to: ", size.inventory);
        return;
      }
    });
  };

  // REF
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    const content = contentRef.current;

    if (content.scrollWidth > container.clientWidth) {
      setIsOverflowing(true);
    } else {
      setIsOverflowing(false);
    }
  }, []);

  const handleMouseEnter = () => {
    const container = containerRef.current;

    if (isOverflowing) {
      container.classList.remove("truncate");
      container.classList.remove("text-ellipsis");
      container.classList.remove("overflow-hidden");
      container.classList.add("animate-marquee");
    }
  };

  const handleMouseLeave = () => {
    const container = containerRef.current;
    container.classList.add("truncate");
    container.classList.add("text-ellipsis");
    container.classList.add("overflow-hidden");
    container.classList.remove("animate-marquee");
  };

  return (
    <div
      className={
        "w-44 md:w-60 md:pb-2 rounded-md overflow-hidden shadow-lg bg-white flex flex-col justify-between"
      }
    >
      <Link to={`/store/products/${id}`}>
        {/* <img className={"w-full h-64 cursor-pointer"} src={image} alt="Product" /> */}
        <img className={"w-full cursor-pointer"} src="https://picsum.photos/200" alt="Product" />
        <div className="px-4 pt-4 flex flex-col justify-between cursor-pointer">
          {/* truncate text-ellipsis overflow-hidden  */}
          <h3 className="font-semibold">{brand}</h3>
          {/* hover:animate-marquee whitespace-nowrap */}

          <div
            className="marquee-container truncate text-ellipsis overflow-hidden"
            ref={containerRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <h4
              className="marquee-content inline-block whitespace-nowrap"
              ref={contentRef}
            >
              {title + " "}
              {color && <span className="text-sm md:text-base">({color})</span>}
            </h4>
          </div>
          {/* <h4 className=" text-sm md:text-base leading-6 h-auto">
            <marquee behavior="" direction="">
              {title + " "}
              {color && <span className="text-sm md:text-base">({color})</span>}
            </marquee>
          </h4> */}
          <div className="mt-2 flex justify-between items-center">
            <p className="font-semibold text-lg">₹ {price}</p>
            {rating && (
              <div className="flex items-center">
                <FontAwesomeIcon
                  icon={faStar}
                  className="text-yellow-400 text-xs mr-1"
                />
                <p className="text-sm">{rating}</p>
              </div>
            )}
          </div>
        </div>
      </Link>
      {!outOfStock ? (
        <div className="flex flex-col md:flex-row justify-between items-center md:space-x-4 my-2 md:my-3 px-6">
          {sizes?.length > 0 && (
            <div className="flex justify-between items-center">
              {/* <p className="md:hidden">Size</p> */}
              <select
                id="size"
                name="size"
                className={
                  notSelected
                    ? "block w-16 p-1 border border-red-500 bg-white rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-ambhosOrange focus:border-ambhosOrange sm:text-sm"
                    : "block w-16 p-1 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-ambhosOrange focus:border-ambhosOrange sm:text-sm"
                }
                value={selectedSize}
                onChange={handleChange}
              >
                <option value="">Size</option>
                {sizes?.map(
                  (size) =>
                    size.inventory > 0 && (
                      <option value={size.size}>{size.size}</option>
                    )
                )}
              </select>
            </div>
          )}
          {/* For color selection if only color */}
          {/* {sizes.length > 0 && (
          <div className="flex w-3/4 justify-between items-center">
            <p className="md:hidden">Size</p>
            <select
              id="size"
              name="size"
              className="block w-12 p-1 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-ambhosOrange focus:border-ambhosOrange sm:text-sm"
              value={selectedSize}
              onChange={(e) => setSelectedSize(e.target.value)}
            >
              {sizes?.map((size) => (
                <option value={size.size}>{size.size}</option>
              ))}
            </select>
          </div>
        )} */}
          <button
            onClick={() => {
              if (selectedSize !== "") {
                handleCartUpdate(id, selectedSize, inventory);
                setNotSelected(false);
              } else {
                setNotSelected(true);
              }
            }}
            className="bg-ambhosOrange w-full hover:opacity-90 active:scale-95 text-white text-sm font-semibold py-2 px-3 rounded-lg my-3 md:my-0"
          >
            Add to Cart
          </button>
        </div>
      ) : (
        <div className="flex justify-center items-center my-2 md:my-3">
          <p className="text-red-500">Out of Stock</p>
        </div>
      )}
      <div className="flex justify-center"></div>
    </div>
  );
}
